<template>
	<div class="container-fluid">

		<h4 class="text-center mb-5">Welcome on HTT Interactome</h4>
		<gene-search></gene-search>
	
	</div>
</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import { mapGetters } from 'vuex';
import GeneView from '@/components/geneView'
import geneSearch from '@/components/geneSearch'

export default {
	name: 'Home',
	components:{geneSearch},
	data () {
		return {
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser'
		}),
	},
	methods:{
		changeNav(nav){
			let _this = this;
			_this.nav = nav;
		},
	},
	mounted() {
		var _this = this;	
		_this.$store.dispatch('getDatasets').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });
		_this.$store.dispatch('getLists').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>

